interface Bounds {
  top: number;
  bottom: number;
}

export const getAnchorBounds = (el: Element): Bounds => {
  let node = el;
  while (getComputedStyle(node).display === 'inline' && node.children.length === 1) {
    node = node.children[0];
  }

  const { top, bottom } = node.getBoundingClientRect();
  return { top, bottom };
};
